// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddingHomepageHeroSection_container__lw6mZ {
  background-color: #0f0f13;
  color: #ffffff;
  padding: 32px;
  border-radius: 12px;
  max-width: 1200px;
  margin: 0 auto;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
}

.AddingHomepageHeroSection_header__xuIDz {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.AddingHomepageHeroSection_header__xuIDz h1 {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(90deg, #ff0000, #ff3333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 30px;
}

.AddingHomepageHeroSection_addButton__RQ7DS {
  background: linear-gradient(90deg, #ff0000, #ff2200);
  color: #fff8f8;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.AddingHomepageHeroSection_addButton__RQ7DS:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);
}

.AddingHomepageHeroSection_currentHero__PVGPA {
  margin-top: 24px;
}

/* Hero Grid Layout */
.AddingHomepageHeroSection_heroGrid__3mXAX {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 4 columns */
  gap: 10px;
}

.AddingHomepageHeroSection_heroCard__IWGVL {
  background-color: #1a1a22;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.AddingHomepageHeroSection_heroCard__IWGVL:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(255, 0, 0, 0.2);
}

.AddingHomepageHeroSection_heroImageContainer__G4Sjv {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.AddingHomepageHeroSection_heroImageContainer__G4Sjv img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.AddingHomepageHeroSection_heroCard__IWGVL:hover .AddingHomepageHeroSection_heroImageContainer__G4Sjv img {
  transform: scale(1.1);
}

.AddingHomepageHeroSection_heroOverlay__AAnvk {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px;
}

.AddingHomepageHeroSection_heroCard__IWGVL:hover .AddingHomepageHeroSection_heroOverlay__AAnvk {
  opacity: 1;
}

.AddingHomepageHeroSection_heroActions__SQzRf {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.AddingHomepageHeroSection_playButton__Lu7or {
  background-color: #ff0000;
  color: white;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease, background-color 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.AddingHomepageHeroSection_playButton__Lu7or:hover {
  transform: scale(1.1);
  background-color: #ff2200;
}

.AddingHomepageHeroSection_removeButton__TIkWy {
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffcccc;
  transition: background-color 0.3s ease;
}

.AddingHomepageHeroSection_removeButton__TIkWy:hover {
  background-color: rgba(255, 0, 0, 0.8);
}

.AddingHomepageHeroSection_positionBadge__N7N86 {
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffcccc;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  align-self: flex-end;
}

.AddingHomepageHeroSection_heroContent__wSRj7 {
  padding: 16px;
}

.AddingHomepageHeroSection_heroContent__wSRj7 h3 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff0f0;
}

.AddingHomepageHeroSection_heroMeta__3hibk {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.AddingHomepageHeroSection_category__OvL-7 {
  display: inline-block;
  background: linear-gradient(90deg, #ff0000, #ff2200);
  color: #fff8f8;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.AddingHomepageHeroSection_creator__szKGd {
  color: #ffcccc;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.AddingHomepageHeroSection_description__V8Vp4 {
  font-size: 14px;
  line-height: 1.5;
  color: #ffdddd;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Empty state */
.AddingHomepageHeroSection_emptyState__NOnP5 {
  text-align: center;
  padding: 48px 24px;
  background-color: #1a1a22;
  border-radius: 12px;
  border: 2px dashed #2a2a3a;
}

.AddingHomepageHeroSection_emptyState__NOnP5 h2 {
  font-size: 22px;
  margin-bottom: 12px;
  color: #fff0f0;
}

.AddingHomepageHeroSection_emptyState__NOnP5 p {
  color: #ffcccc;
  margin-bottom: 24px;
}

.AddingHomepageHeroSection_addEmptyButton__oEF8m {
  background: linear-gradient(90deg, #ff0000, #ff2200);
  color: #fff8f8;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.AddingHomepageHeroSection_addEmptyButton__oEF8m:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);
}

/* Modal styles */
.AddingHomepageHeroSection_modalOverlay__HKBNK {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.AddingHomepageHeroSection_modal__9RWrv {
  background-color: #1a1a22;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.AddingHomepageHeroSection_modalHeader__zImXa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #2a2a3a;
}

.AddingHomepageHeroSection_modalHeader__zImXa h2 {
  margin: 0;
  font-size: 22px;
  background: linear-gradient(90deg, #ff0000, #ff3333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.AddingHomepageHeroSection_closeButton__Gp2d1 {
  background: none;
  border: none;
  color: #ffcccc;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.AddingHomepageHeroSection_closeButton__Gp2d1:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.AddingHomepageHeroSection_modalBody__u6bqk {
  padding: 24px;
}

.AddingHomepageHeroSection_formGroup__Zhm2D {
  margin-bottom: 24px;
}

.AddingHomepageHeroSection_formGroup__Zhm2D label {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  color: #fff0f0;
}

/* Position selector */
.AddingHomepageHeroSection_positionSelector__4ktFM {
  display: flex;
  gap: 10px;
}

.AddingHomepageHeroSection_positionButton__m8JPZ {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2a2a3a;
  color: #ffcccc;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.AddingHomepageHeroSection_positionButton__m8JPZ:hover {
  background-color: #3a3a4a;
  transform: translateY(-2px);
}

.AddingHomepageHeroSection_activePosition__oF7WX {
  background: linear-gradient(90deg, #ff0000, #ff2200);
  box-shadow: 0 4px 10px rgba(255, 0, 0, 0.3);
  color: #fff8f8;
}

.AddingHomepageHeroSection_enhancedSelect__aXk8Z {
  width: 100%;
  padding: 12px;
  background-color: #2a2a3a;
  border: 1px solid #444;
  border-radius: 8px;
  color: #fff0f0;
  font-size: 16px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px top 50%;
  background-size: 12px auto;
  cursor: pointer;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.AddingHomepageHeroSection_enhancedSelect__aXk8Z:focus {
  outline: none;
  border-color: #ff0000;
  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);
}

.AddingHomepageHeroSection_previewSection__rbfaA {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #2a2a3a;
}

.AddingHomepageHeroSection_previewSection__rbfaA h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  color: #fff0f0;
}

.AddingHomepageHeroSection_previewCard__S7qwf {
  background-color: #222230;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.AddingHomepageHeroSection_previewCard__S7qwf:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.AddingHomepageHeroSection_previewImage__zsX8Q {
  width: 100%;
  height: 200px;
}

.AddingHomepageHeroSection_previewImage__zsX8Q img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AddingHomepageHeroSection_previewInfo__rBxWY {
  padding: 16px;
}

.AddingHomepageHeroSection_previewInfo__rBxWY h4 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #fff0f0;
}

.AddingHomepageHeroSection_previewMeta__PXHK9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.AddingHomepageHeroSection_previewStats__6bhMP {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ffcccc;
  font-size: 13px;
}

.AddingHomepageHeroSection_modalFooter__Q\\+AQd {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #2a2a3a;
}

.AddingHomepageHeroSection_cancelButton__Qz51o {
  background-color: transparent;
  border: 1px solid #444;
  color: #ffcccc;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.AddingHomepageHeroSection_cancelButton__Qz51o:hover {
  background-color: #2a2a3a;
  border-color: #555;
}

.AddingHomepageHeroSection_saveButton__aGJo0 {
  background: linear-gradient(90deg, #ff0000, #ff2200);
  color: #fff8f8;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.AddingHomepageHeroSection_saveButton__aGJo0:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);
}

.AddingHomepageHeroSection_saveButton__aGJo0:disabled {
  background: #5c5c5c;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Animations */
.AddingHomepageHeroSection_fadeIn__xFl-0, .AddingHomepageHeroSection_slideInUp__BiqRT, .AddingHomepageHeroSection_fadeInScale__S7GZl, .AddingHomepageHeroSection_slideIn__LCg77 {
  animation: AddingHomepageHeroSection_fadeIn__xFl-0 0.5s ease forwards;
}

@keyframes AddingHomepageHeroSection_fadeIn__xFl-0 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes AddingHomepageHeroSection_slideInUp__BiqRT {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes AddingHomepageHeroSection_fadeInScale__S7GZl {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes AddingHomepageHeroSection_slideIn__LCg77 {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
/* Add these styles to your existing CSS module file */

.AddingHomepageHeroSection_imageUploadSection__vIB\\+R {
  margin-top: 1.5rem;
  border-top: 1px solid #eaeaea;
  padding-top: 1.5rem;
}

.AddingHomepageHeroSection_imageUploadContainer__hNApO {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}

.AddingHomepageHeroSection_imageUploadButton__spYjg {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: transparent;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.AddingHomepageHeroSection_imageUploadButton__spYjg:hover {
  border-color: #666;
  background-color: #f3f3f3;
}

.AddingHomepageHeroSection_fileInput__QLP0D {
  display: none;
}

.AddingHomepageHeroSection_uploadLabel__roehK {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #555;
}

.AddingHomepageHeroSection_uploadLabel__roehK span {
  font-size: 0.9rem;
}

.AddingHomepageHeroSection_imagePreviewWrapper__7zb0u {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.AddingHomepageHeroSection_imagePreview__lPEbV {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.AddingHomepageHeroSection_removeImageButton__33\\+fD {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  color: #ff4d4f;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.2s ease;
}

.AddingHomepageHeroSection_removeImageButton__33\\+fD:hover {
  opacity: 1;
  background-color: white;
}

.AddingHomepageHeroSection_imageHint__HFs9t {
  display: block;
  margin-top: 0.5rem;
  color: #888;
  font-size: 0.8rem;
}

.AddingHomepageHeroSection_previewHeroImage__4ecMW {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 6px 6px 0 0;
}

/* Responsive styles */
@media (min-width: 768px) {
  .AddingHomepageHeroSection_imageUploadSection__vIB\\+R {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }
  
  .AddingHomepageHeroSection_imagePreviewWrapper__7zb0u {
    height: 180px;
  }
  
  .AddingHomepageHeroSection_imagePreview__lPEbV {
    height: 100%;
    object-fit: cover;
  }
}

@media (max-width: 767px) {
  .AddingHomepageHeroSection_imageUploadSection__vIB\\+R {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .AddingHomepageHeroSection_imagePreviewWrapper__7zb0u {
    height: auto;
    max-height: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/components/Herosectionpages/AddingHomepageHeroSection.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2EAA2E;EAC3E,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2DAA2D;EAC3D,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oDAAoD;EACpD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yDAAof;EACpf,4BAA4B;EAC5B,uCAAuC;EACvC,0BAA0B;EAC1B,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,qEAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA,sDAAsD;;AAEtD;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,0CAA0C;EAC1C,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  background-color: #0f0f13;\n  color: #ffffff;\n  padding: 32px;\n  border-radius: 12px;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h1 {\n  font-size: 28px;\n  font-weight: 700;\n  background: linear-gradient(90deg, #ff0000, #ff3333);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-right: 30px;\n}\n\n.addButton {\n  background: linear-gradient(90deg, #ff0000, #ff2200);\n  color: #fff8f8;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n}\n\n.addButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);\n}\n\n.currentHero {\n  margin-top: 24px;\n}\n\n/* Hero Grid Layout */\n.heroGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 4 columns */\n  gap: 10px;\n}\n\n.heroCard {\n  background-color: #1a1a22;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.heroCard:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 30px rgba(255, 0, 0, 0.2);\n}\n\n.heroImageContainer {\n  position: relative;\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n}\n\n.heroImageContainer img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.heroCard:hover .heroImageContainer img {\n  transform: scale(1.1);\n}\n\n.heroOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 70%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 12px;\n}\n\n.heroCard:hover .heroOverlay {\n  opacity: 1;\n}\n\n.heroActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.playButton {\n  background-color: #ff0000;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.playButton:hover {\n  transform: scale(1.1);\n  background-color: #ff2200;\n}\n\n.removeButton {\n  background-color: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #ffcccc;\n  transition: background-color 0.3s ease;\n}\n\n.removeButton:hover {\n  background-color: rgba(255, 0, 0, 0.8);\n}\n\n.positionBadge {\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #ffcccc;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  align-self: flex-end;\n}\n\n.heroContent {\n  padding: 16px;\n}\n\n.heroContent h3 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 18px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #fff0f0;\n}\n\n.heroMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.category {\n  display: inline-block;\n  background: linear-gradient(90deg, #ff0000, #ff2200);\n  color: #fff8f8;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.creator {\n  color: #ffcccc;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.description {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #ffdddd;\n  margin-bottom: 16px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* Empty state */\n.emptyState {\n  text-align: center;\n  padding: 48px 24px;\n  background-color: #1a1a22;\n  border-radius: 12px;\n  border: 2px dashed #2a2a3a;\n}\n\n.emptyState h2 {\n  font-size: 22px;\n  margin-bottom: 12px;\n  color: #fff0f0;\n}\n\n.emptyState p {\n  color: #ffcccc;\n  margin-bottom: 24px;\n}\n\n.addEmptyButton {\n  background: linear-gradient(90deg, #ff0000, #ff2200);\n  color: #fff8f8;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 24px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n}\n\n.addEmptyButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);\n}\n\n/* Modal styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n}\n\n.modal {\n  background-color: #1a1a22;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #2a2a3a;\n}\n\n.modalHeader h2 {\n  margin: 0;\n  font-size: 22px;\n  background: linear-gradient(90deg, #ff0000, #ff3333);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: #ffcccc;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.closeButton:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.modalBody {\n  padding: 24px;\n}\n\n.formGroup {\n  margin-bottom: 24px;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 500;\n  font-size: 16px;\n  color: #fff0f0;\n}\n\n/* Position selector */\n.positionSelector {\n  display: flex;\n  gap: 10px;\n}\n\n.positionButton {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #2a2a3a;\n  color: #ffcccc;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.positionButton:hover {\n  background-color: #3a3a4a;\n  transform: translateY(-2px);\n}\n\n.activePosition {\n  background: linear-gradient(90deg, #ff0000, #ff2200);\n  box-shadow: 0 4px 10px rgba(255, 0, 0, 0.3);\n  color: #fff8f8;\n}\n\n.enhancedSelect {\n  width: 100%;\n  padding: 12px;\n  background-color: #2a2a3a;\n  border: 1px solid #444;\n  border-radius: 8px;\n  color: #fff0f0;\n  font-size: 16px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px top 50%;\n  background-size: 12px auto;\n  cursor: pointer;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.enhancedSelect:focus {\n  outline: none;\n  border-color: #ff0000;\n  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);\n}\n\n.previewSection {\n  margin-top: 28px;\n  padding-top: 20px;\n  border-top: 1px solid #2a2a3a;\n}\n\n.previewSection h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 18px;\n  color: #fff0f0;\n}\n\n.previewCard {\n  background-color: #222230;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.previewCard:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n.previewImage {\n  width: 100%;\n  height: 200px;\n}\n\n.previewImage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.previewInfo {\n  padding: 16px;\n}\n\n.previewInfo h4 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  color: #fff0f0;\n}\n\n.previewMeta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.previewStats {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #ffcccc;\n  font-size: 13px;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #2a2a3a;\n}\n\n.cancelButton {\n  background-color: transparent;\n  border: 1px solid #444;\n  color: #ffcccc;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.cancelButton:hover {\n  background-color: #2a2a3a;\n  border-color: #555;\n}\n\n.saveButton {\n  background: linear-gradient(90deg, #ff0000, #ff2200);\n  color: #fff8f8;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n}\n\n.saveButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);\n}\n\n.saveButton:disabled {\n  background: #5c5c5c;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Animations */\n.fadeIn, .slideInUp, .fadeInScale, .slideIn {\n  animation: fadeIn 0.5s ease forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n/* Add these styles to your existing CSS module file */\n\n.imageUploadSection {\n  margin-top: 1.5rem;\n  border-top: 1px solid #eaeaea;\n  padding-top: 1.5rem;\n}\n\n.imageUploadContainer {\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.5rem;\n}\n\n.imageUploadButton {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  background-color: transparent;\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.imageUploadButton:hover {\n  border-color: #666;\n  background-color: #f3f3f3;\n}\n\n.fileInput {\n  display: none;\n}\n\n.uploadLabel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  color: #555;\n}\n\n.uploadLabel span {\n  font-size: 0.9rem;\n}\n\n.imagePreviewWrapper {\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.imagePreview {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n.removeImageButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: rgba(255, 255, 255, 0.9);\n  color: #ff4d4f;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  opacity: 0.8;\n  transition: all 0.2s ease;\n}\n\n.removeImageButton:hover {\n  opacity: 1;\n  background-color: white;\n}\n\n.imageHint {\n  display: block;\n  margin-top: 0.5rem;\n  color: #888;\n  font-size: 0.8rem;\n}\n\n.previewHeroImage {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 6px 6px 0 0;\n}\n\n/* Responsive styles */\n@media (min-width: 768px) {\n  .imageUploadSection {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n  }\n  \n  .imagePreviewWrapper {\n    height: 180px;\n  }\n  \n  .imagePreview {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n@media (max-width: 767px) {\n  .imageUploadSection {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  \n  .imagePreviewWrapper {\n    height: auto;\n    max-height: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddingHomepageHeroSection_container__lw6mZ`,
	"header": `AddingHomepageHeroSection_header__xuIDz`,
	"addButton": `AddingHomepageHeroSection_addButton__RQ7DS`,
	"currentHero": `AddingHomepageHeroSection_currentHero__PVGPA`,
	"heroGrid": `AddingHomepageHeroSection_heroGrid__3mXAX`,
	"heroCard": `AddingHomepageHeroSection_heroCard__IWGVL`,
	"heroImageContainer": `AddingHomepageHeroSection_heroImageContainer__G4Sjv`,
	"heroOverlay": `AddingHomepageHeroSection_heroOverlay__AAnvk`,
	"heroActions": `AddingHomepageHeroSection_heroActions__SQzRf`,
	"playButton": `AddingHomepageHeroSection_playButton__Lu7or`,
	"removeButton": `AddingHomepageHeroSection_removeButton__TIkWy`,
	"positionBadge": `AddingHomepageHeroSection_positionBadge__N7N86`,
	"heroContent": `AddingHomepageHeroSection_heroContent__wSRj7`,
	"heroMeta": `AddingHomepageHeroSection_heroMeta__3hibk`,
	"category": `AddingHomepageHeroSection_category__OvL-7`,
	"creator": `AddingHomepageHeroSection_creator__szKGd`,
	"description": `AddingHomepageHeroSection_description__V8Vp4`,
	"emptyState": `AddingHomepageHeroSection_emptyState__NOnP5`,
	"addEmptyButton": `AddingHomepageHeroSection_addEmptyButton__oEF8m`,
	"modalOverlay": `AddingHomepageHeroSection_modalOverlay__HKBNK`,
	"modal": `AddingHomepageHeroSection_modal__9RWrv`,
	"modalHeader": `AddingHomepageHeroSection_modalHeader__zImXa`,
	"closeButton": `AddingHomepageHeroSection_closeButton__Gp2d1`,
	"modalBody": `AddingHomepageHeroSection_modalBody__u6bqk`,
	"formGroup": `AddingHomepageHeroSection_formGroup__Zhm2D`,
	"positionSelector": `AddingHomepageHeroSection_positionSelector__4ktFM`,
	"positionButton": `AddingHomepageHeroSection_positionButton__m8JPZ`,
	"activePosition": `AddingHomepageHeroSection_activePosition__oF7WX`,
	"enhancedSelect": `AddingHomepageHeroSection_enhancedSelect__aXk8Z`,
	"previewSection": `AddingHomepageHeroSection_previewSection__rbfaA`,
	"previewCard": `AddingHomepageHeroSection_previewCard__S7qwf`,
	"previewImage": `AddingHomepageHeroSection_previewImage__zsX8Q`,
	"previewInfo": `AddingHomepageHeroSection_previewInfo__rBxWY`,
	"previewMeta": `AddingHomepageHeroSection_previewMeta__PXHK9`,
	"previewStats": `AddingHomepageHeroSection_previewStats__6bhMP`,
	"modalFooter": `AddingHomepageHeroSection_modalFooter__Q+AQd`,
	"cancelButton": `AddingHomepageHeroSection_cancelButton__Qz51o`,
	"saveButton": `AddingHomepageHeroSection_saveButton__aGJo0`,
	"fadeIn": `AddingHomepageHeroSection_fadeIn__xFl-0`,
	"slideInUp": `AddingHomepageHeroSection_slideInUp__BiqRT`,
	"fadeInScale": `AddingHomepageHeroSection_fadeInScale__S7GZl`,
	"slideIn": `AddingHomepageHeroSection_slideIn__LCg77`,
	"imageUploadSection": `AddingHomepageHeroSection_imageUploadSection__vIB+R`,
	"imageUploadContainer": `AddingHomepageHeroSection_imageUploadContainer__hNApO`,
	"imageUploadButton": `AddingHomepageHeroSection_imageUploadButton__spYjg`,
	"fileInput": `AddingHomepageHeroSection_fileInput__QLP0D`,
	"uploadLabel": `AddingHomepageHeroSection_uploadLabel__roehK`,
	"imagePreviewWrapper": `AddingHomepageHeroSection_imagePreviewWrapper__7zb0u`,
	"imagePreview": `AddingHomepageHeroSection_imagePreview__lPEbV`,
	"removeImageButton": `AddingHomepageHeroSection_removeImageButton__33+fD`,
	"imageHint": `AddingHomepageHeroSection_imageHint__HFs9t`,
	"previewHeroImage": `AddingHomepageHeroSection_previewHeroImage__4ecMW`
};
export default ___CSS_LOADER_EXPORT___;
